module.exports = {
  onboardingComponentEvents: {
    Onboarding: {
      code: 'Onboarding',
      events: {
        CloseClicked: {
          description: 'Triggered when user clicks on "X" button on onboarding flow.',
          eventHub: {
            code: 'CloseClicked',
            action: 'ON_[$.path]_CloseClicked',
            dataKeys: ['path']
          },
          ga: {
            action: 'ON-[$.path]-CloseClicked'
          }
        },
        Back: {
          description: 'Triggered when user performs action on the back button on onboarding flow.',
          eventHub: {
            code: 'Back',
            action: 'ON_[$.path]_Back[$.action]',
            dataKeys: ['action', 'path']
          },
          ga: {
            action: 'ON-[$.path]-Back[$.action]'
          }
        }
      }
    },
    OnboardingPlanType: {
      code: 'SelectPlan',
      events: {
        PlanSelection: {
          description: 'Triggered when user selects the plan type',
          eventHub: {
            action: 'PlanSelection',
            dataKeys: ['planType']
          },
          ga: {
            action: 'Select Plan Type'
          }
        }
      }
    },
    OnboardingBeneficiaries: {
      code: 'NumberofBenes',
      events: {
        NumberofBenes: {
          description: 'Triggered when user selects the number of benes',
          eventHub: {
            action: 'NumberofBenes',
            dataKeys: ['NumberofBenes']
          },
          ga: {
            action: 'Select Number of Benes'
          }
        }
      }
    },
    OnboardingCoApplicant: {
      code: 'IndividualJointSelection',
      events: {
        IndividualJointSelection: {
          description: 'Triggered when user submits the coapplicant information',
          eventHub: {
            action: 'IndividualJointSelection',
            dataKeys: ['coApplicant', 'coSubscriberEmail', 'coSubscriberFirstName', 'coSubscriberLastName']
          },
          ga: {
            action: 'Submit CoApplicant Info'
          }
        }
      }
    },
    OnboardingIPSQuestion: {
      code: 'IPS',
      events: {
        IPS_BeneAgeInvestment: {
          description: 'Triggered when user submits the IPS Question Bene Age Investment',
          eventHub: {
            code: 'BeneAgeInvestment',
            action: 'IPS_BeneAgeInvestment',
            dataKeys: ['ipsResponse']
          },
          ga: {
            action: 'Submit Bene Age Investment'
          }
        },
        IPS_PurposeOfAccount: {
          description: 'Triggered when user submits the IPS Question Purpose of Account',
          eventHub: {
            code: 'PurposeOfAccount',
            action: 'IPS_PurposeOfAccount',
            dataKeys: ['ipsResponse']
          },
          ga: {
            action: 'Submit Purpose of Account'
          }
        },
        IPS_LivingExpenses: {
          description: 'Triggered when user submits the IPS Question Living Expense',
          eventHub: {
            code: 'LivingExpenses',
            action: 'IPS_LivingExpenses',
            dataKeys: ['ipsResponse']
          },
          ga: {
            action: 'Submit Living Expense'
          }
        },
        IPS_ExpectedIncome: {
          description: 'Triggered when user submits the IPS Question Expected Income',
          eventHub: {
            code: 'ExpectedIncome',
            action: 'IPS_ExpectedIncome',
            dataKeys: ['ipsResponse']
          },
          ga: {
            action: 'Submit Expected Income'
          }
        },
        IPS_ExpectedSavings: {
          description: 'Triggered when user submits the IPS Question Expected Savings',
          eventHub: {
            code: 'ExpectedSavings',
            action: 'IPS_ExpectedSavings',
            dataKeys: ['ipsResponse']
          },
          ga: {
            action: 'Submit Expected Savings'
          }
        },
        IPS_FinancialPersonality: {
          description: 'Triggered when user submits the IPS Question Financial Personality',
          eventHub: {
            code: 'FinancialPersonality',
            action: 'IPS_FinancialPersonality',
            dataKeys: ['ipsResponse']
          },
          ga: {
            action: 'Submit Financial Personality'
          }
        },
        IPS_20PercentDrop: {
          description: 'Triggered when user submits the IPS Question 20 Percent Drop',
          eventHub: {
            code: '20PercentDrop',
            action: 'IPS_20PercentDrop',
            dataKeys: ['ipsResponse']
          },
          ga: {
            action: 'Submit 20 Percent Drop'
          }
        },
        IPS_EventsFeared: {
          description: 'Triggered when user submits the IPS Question Events Feared',
          eventHub: {
            code: 'EventsFeared',
            action: 'IPS_EventsFeared',
            dataKeys: ['ipsResponse']
          },
          ga: {
            action: 'Submit Events Feared'
          }
        }
      }
    },
    OnboardingRiskProfile: {
      code: 'RiskScore',
      events: {
        RiskScore: {
          description: 'Triggered when user clicks continue from risk profile screen',
          eventHub: {
            action: 'RiskScore',
            dataKeys: ['riskScore']
          },
          ga: {
            action: 'Submit Risk Profile'
          }
        }
      }
    },
    OnboardingNewGrants: {
      code: 'Grants',
      events: {
        StartGrants: {
          description: 'Triggered when user loads into grants page.',
          eventHub: {
            action: 'ON_Grants_StartGrants',
            code: 'StartGrants',
            dataKeys: []
          },
          ga: {
            action: 'ON-Grants-StartGrants'
          }
        },
        SubmitGrants: {
          description: 'Triggered whenever user hits continue on grants step of the onboarding flow.',
          eventHub: {
            action: 'ON_Grants_SubmitGrants',
            code: 'SubmitGrants',
            dataKeys: ['grants']
          },
          ga: {
            action: 'ON-Grants-SubmitGrants'
          }
        }
      }
    },
    OnboardingSIN: {
      code: 'SubSIN',
      events: {
        StartSubSIN: {
          description: "Triggered when user loads subscriber's SIN page",
          eventHub: {
            code: 'StartSubSIN',
            action: 'ON_SubSIN_StartSubSIN',
            dataKeys: []
          },
          ga: {
            action: 'ON-SubSIN-StartSubSIN'
          }
        },
        SubmitSubSIN: {
          description: "Triggered when user submits subscriber's SIN",
          eventHub: {
            action: 'ON_SubSIN_SubmitSubSIN',
            dataKeys: []
          },
          ga: {
            action: 'ON-SubSIN-SubmitSubSIN'
          }
        }
      }
    },
    OnboardingBeneficiarySIN: {
      code: 'BeneSIN',
      events: {
        StartBeneSIN: {
          description: "Triggered when user loads beneficiaries' SIN page",
          eventHub: {
            code: 'StartBeneSIN',
            action: 'ON_BeneSIN_StartBeneSIN',
            dataKeys: []
          },
          ga: {
            action: 'ON-BeneSIN-StartBeneSIN'
          }
        },
        SubmitBeneSIN: {
          description: "Triggered when user submits beneficiaries' SIN",
          eventHub: {
            action: 'ON_BeneSIN_SubmitBeneSIN',
            dataKeys: []
          },
          ga: {
            action: 'ON-BeneSIN-SubmitBeneSIN'
          }
        }
      }
    },
    OnboardingReview: {
      code: 'Review',
      events: {
        Review: {
          description: 'Triggered when user clicks continue on review screen',
          eventHub: {
            action: 'Review',
            dataKeys: []
          },
          ga: {
            action: 'Submit Review'
          }
        }
      }
    },
    OnboardingTermsAndCondition: {
      code: '',
      events: {
        TermsAndCondition: {
          description: 'Triggered when user submits terms and condition',
          eventHub: {
            code: 'TermsAndCondition',
            action: 'TermsAndCondition',
            dataKeys: []
          },
          ga: {
            action: 'Submit TermsAndCondition'
          }
        },
        Somethingwentwrong: {
          description: 'Triggered when user submits terms and condition and onboarding fails',
          eventHub: {
            code: 'Somethingwentwrong',
            action: 'Somethingwentwrong',
            dataKeys: []
          },
          ga: {
            action: 'Error'
          }
        },
        Decline: {
          description: 'Triggered when user clicks on decline button on terms and condition screen',
          eventHub: {
            code: 'Decline',
            action: 'Decline',
            dataKeys: []
          },
          ga: {
            action: 'Decline Application'
          }
        }
      }
    },
    OnboardingSuccess: {
      code: '',
      events: {
        Success: {
          description: 'Triggered when user lands on success screen',
          eventHub: {
            code: 'Success',
            action: 'Success',
            dataKeys: []
          },
          ga: {
            action: 'Success'
          }
        },
        Dashboard: {
          description: 'Triggered when user clicks on dashboard button on success screen',
          eventHub: {
            code: 'Dashboard',
            action: 'Dashboard',
            dataKeys: []
          },
          ga: {
            action: 'Go to Dashboard'
          }
        },
        Contribute: {
          description: 'Triggered when user clicks on contribution button on success screen',
          eventHub: {
            code: 'Contribute',
            action: 'Contribute',
            dataKeys: []
          },
          ga: {
            action: 'Go to Contribution Flow'
          }
        }
      }
    },
    OnboardingCalculator: {
      code: 'Onboarding_Calculator',
      events: {
        Calculator_Started: {
          description: 'Triggered when user lands on calculator page',
          eventHub: {
            code: 'Calculator_Started',
            action: 'Calculator_Started',
            dataKeys: []
          },
          ga: {
            action: 'User lands on calculator page'
          }
        },
        Calculator_Popup_Viewed: {
          description: 'Triggered when user clicks the popup link',
          eventHub: {
            code: 'Calculator_Popup_Viewed',
            action: 'Calculator_Popup_Viewed',
            dataKeys: []
          },
          ga: {
            action: 'User clicks the popup link'
          }
        },
        Calculator_Closed: {
          description: 'Triggered when user closes calculator',
          eventHub: {
            code: 'Calculator_Closed',
            action: 'Calculator_Closed',
            dataKeys: []
          },
          ga: {
            action: 'User closes calculator'
          }
        },
        Calculator_Contribution_Updated: {
          description: 'Triggered when user changes the contribution value',
          eventHub: {
            code: 'Calculator_Contribution_Updated',
            action: 'Calculator_Contribution_Updated',
            dataKeys: ['contribution']
          },
          ga: {
            action: 'User changes the contribution value'
          }
        },
        Calculator_Age_Updated: {
          description: 'Triggered when user changes the age value',
          eventHub: {
            code: 'Calculator_Age_Updated',
            action: 'Calculator_Age_Updated',
            dataKeys: ['age']
          },
          ga: {
            action: 'User changes the age value'
          }
        },
        Calculator_Province_Updated: {
          description: 'Triggered when user changes the province value',
          eventHub: {
            code: 'Calculator_Province_Updated',
            action: 'Calculator_Province_Updated',
            dataKeys: ['province']
          },
          ga: {
            action: 'User changes the province value'
          }
        },
        Calculator_Completed: {
          description: 'Triggered when user clicks submit button',
          eventHub: {
            code: 'Calculator_Completed',
            action: 'Calculator_Completed',
            dataKeys: ['childAge', 'contribution', 'province', 'chartData', 'finalYearData', 'calculatedChildAdultYear']
          },
          ga: {
            action: 'User clicks submit button'
          }
        }
      }
    }
  }
};
